import { styled, Theme, CSSObject } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import { Divider, ListItemIcon, Stack, StackProps } from '@mui/material';
import Colors from '@/theme/constants/Colors';
import { Typographies } from '@/theme';

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
});

const DRAWER_WIDTH = 244;
interface DrawerHeaderStyledProps {
  open: boolean;
}
export const DrawerHeaderStyled = styled('div')<DrawerHeaderStyledProps>(
  ({ theme, open }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: open ? 'flex-start' : 'center',
    gap: open ? theme.spacing(1) : 0,
    padding: theme.spacing(2, 2, 2, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    borderBottom: `1px solid ${theme.palette.dark.dark_3}`,
  }),
);
export const ListItemIconStyled = styled(ListItemIcon)(() => ({
  minWidth: 'auto',
}));

export const SideBarStyled = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiPaper-root': {
    background: theme.palette.dark.dark_2,
    color: Colors.COLOR_WHITE_TEXT,
  },
  width: DRAWER_WIDTH,
  zIndex: 5,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

interface ListItemButtonStyledProps extends StackProps {
  open: boolean;
  selected: boolean;
}
export const SliderItem = styled(Stack)<ListItemButtonStyledProps>(
  ({ theme, open, selected }) => ({
    height: 48,
    position: 'relative',
    cursor: 'pointer',
    width: open ? 'auto' : 56,
    background: selected
      ? theme.palette.primary.light
      : theme.palette.primary.dark,
    borderRadius: theme.spacing(1),
    justifyContent: open ? 'flex-start' : 'center',
    marginLeft: open ? theme.spacing(2) : 'auto',
    marginRight: open ? theme.spacing(2) : 'auto',
    padding: open ? theme.spacing(2) : 0,
  }),
);

export const CounterStyled = styled('div')(({ theme }) => ({
  background: theme.palette.error.main,
  color: theme.palette.white.main,
  fontSize: Typographies.FONT_SIZE_CAPTION_2,
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(4),
  border: `1px solid ${theme.palette.dark.dark_2}`,
  minWidth: '34px',
  textAlign: 'center',
}));
export const CounterAbsoluteStyled = styled(CounterStyled)(({ theme }) => ({
  position: 'absolute',
  top: -10,
  right: -10,
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.dark.dark_3,
  height: '1px',
  margin: `0px ${theme.spacing(2)}`,
}));
